module.exports = __webpack_public_path__ + "static/media/Colorectal-Follow Up Intake-2@3x.65e7f63c.png";